import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, SendIcon } from 'lucide-react';
interface DemoModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function DemoModal({
  isOpen,
  onClose
}: DemoModalProps) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      onClose();
    }, 3000);
  };
  return <AnimatePresence data-id="element-86">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-87">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-midnight-navy/80 backdrop-blur-md" data-id="element-88" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-lg bg-stark-white rounded-2xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col" data-id="element-89">
            <button onClick={onClose} className="absolute top-4 right-4 p-2 text-midnight-navy/40 hover:text-midnight-navy transition-colors" data-id="element-90">
              <XIcon className="w-6 h-6" data-id="element-91" />
            </button>

            <div className="p-8 md:p-12 overflow-y-auto custom-scrollbar" data-id="element-92">
              {!isSubmitted ? <div className="space-y-8" data-id="element-93">
                  <div className="space-y-2" data-id="element-94">
                    <h2 className="text-3xl font-manrope font-bold text-midnight-navy" data-id="element-95">
                      Book a Demo
                    </h2>
                    <p className="text-midnight-navy/60" data-id="element-96">
                      See how ROI can transform your restaurant operations.
                    </p>
                  </div>

                  <form onSubmit={handleSubmit} className="space-y-4" data-id="element-97">
                    <div className="grid grid-cols-2 gap-4" data-id="element-98">
                      <div className="space-y-1.5" data-id="element-99">
                        <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-100">
                          First Name
                        </label>
                        <input required type="text" className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors" placeholder="Jane" data-id="element-101" />
                      </div>
                      <div className="space-y-1.5" data-id="element-102">
                        <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-103">
                          Last Name
                        </label>
                        <input required type="text" className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors" placeholder="Doe" data-id="element-104" />
                      </div>
                    </div>

                    <div className="space-y-1.5" data-id="element-105">
                      <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-106">
                        Email
                      </label>
                      <input required type="email" className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors" placeholder="jane@example.com" data-id="element-107" />
                    </div>

                    <div className="space-y-1.5" data-id="element-108">
                      <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-109">
                        Phone
                      </label>
                      <input required type="tel" className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors" placeholder="(555) 000-0000" data-id="element-110" />
                    </div>

                    <div className="space-y-1.5" data-id="element-111">
                      <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-112">
                        Message
                      </label>
                      <textarea rows={3} className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors resize-none" placeholder="How can we help you?" data-id="element-113" />
                    </div>

                    <button type="submit" className="w-full bg-accent-red text-stark-white py-4 rounded-full font-bold hover:bg-red-700 transition-all shadow-xl shadow-accent-red/20 flex items-center justify-center gap-2 mt-4" data-id="element-114">
                      Request Walkthrough
                      <SendIcon className="w-4 h-4" data-id="element-115" />
                    </button>
                  </form>
                </div> : <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="py-12 text-center space-y-6" data-id="element-116">
                  <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto" data-id="element-117">
                    <CheckIcon className="w-10 h-10" data-id="element-118" />
                  </div>
                  <div className="space-y-2" data-id="element-119">
                    <h3 className="text-2xl font-manrope font-bold text-midnight-navy" data-id="element-120">
                      Request Received
                    </h3>
                    <p className="text-midnight-navy/60" data-id="element-121">
                      An operations specialist will be in touch shortly to
                      schedule your demo.
                    </p>
                  </div>
                </motion.div>}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}
function CheckIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-122">
      <polyline points="20 6 9 17 4 12" data-id="element-123" />
    </svg>;
}